<div class="row mb-3">
  <div class="col">
    <span i18n class="font-weight-bold">Settings</span>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="mb-3 section-heading" i18n>SOURCE</div>
    <div class="row mb-2 align-items-center" data-cy="analytics-settings-template">
      <div class="col-5 pr-0">Template:</div>
      <div class="col-7 pl-0">
        <ng-select
          id="analytics-source-template"
          [(ngModel)]="chart.templateId"
          [items]="templates"
          bindLabel="name"
          bindValue="_id"
          [clearable]="false"
          (change)="onTemplateChange()"
        ></ng-select>
      </div>
    </div>
  </div>
  <div class="col">
    <ng-container *ngIf="isChartSetup">
      <div class="mb-3 section-heading" i18n>DATA</div>
      <div class="row mb-2 align-items-center" data-cy="analytics-settings-timeframe">
        <div class="col-5 pr-0">Timeframe:</div>
        <div class="col-7 pl-0">
          <ng-select
            id="analytics-data-timeframe"
            [(ngModel)]="chart.timeframe"
            [items]="timeFrames"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            (change)="onTimeFrameChange()"
          ></ng-select>
        </div>
      </div>
      <div class="row mb-2 align-items-center" data-cy="analytics-settings-interval">
        <div class="col-5 pr-0">Interval:</div>
        <div class="col-7 pl-0">
          <ng-select
            id="analytics-data-interval"
            [(ngModel)]="chart.dateUnit"
            [items]="dateUnits"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            (change)="onDateUnitChange()"
          ></ng-select>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="col">
    <ng-container *ngIf="isChartSetup">
      <div class="mb-3 section-heading" i18n>VISUALISE</div>
      <div class="row mb-2 align-items-center" data-cy="analytics-settings-show">
        <div class="col-5 pr-0">Show as:</div>
        <div class="col-7 pl-0">
          <ng-select
            id="analytics-visualize-show-as"
            [(ngModel)]="chart.showAs"
            [items]="showAsOptions"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            (change)="onShowAsChange()"
          ></ng-select>
        </div>
      </div>
      <div class="row mb-2 align-items-center" data-cy="analytics-settings-breakdown">
        <div class="col-5 pr-0">Breakdown by:</div>
        <div class="col-7 pl-0">
          <ng-select
            id="analytics-visualize-breakdown-by"
            [(ngModel)]="chart.breakdownBy"
            [items]="breakdownOptions"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            (change)="onBreakdownChange()"
          ></ng-select>
        </div>
      </div>
    </ng-container>
  </div>
</div>
